export const en = {
    titreOnglet: "Line of credit Detail | Desjardins"
};
